import { Route, Switch, useRouteMatch } from "react-router-dom";

import { NotFound } from "@app/shared/ErrorPages";
import { ProviderNetworkImportPage } from "./components/ProviderNetworkImportPage";
import { ProviderNetworkImportProvider } from "./providerNetworksImportContext";
import { JSX } from "react";

export const ProviderNetworkImportRouter = (): JSX.Element => {
  const match = useRouteMatch();
  return (
    <ProviderNetworkImportProvider>
      <Switch>
        <Route path={`${match.path}/:networkId/version/:versionId`}>
          <ProviderNetworkImportPage />
        </Route>
        <Route>
          <NotFound />
        </Route>
      </Switch>
    </ProviderNetworkImportProvider>
  );
};

export default ProviderNetworkImportRouter;
